var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('v-chip',{staticClass:"cursor-pointer",style:(`border-color: ${_vm.getColor} !important; color: ${_vm.getColor} !important;`),attrs:{"outlined":""}},[_vm._v("\n    "+_vm._s(_vm.value.nombre)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }